import { Link } from "react-router-dom";

import { useOrders } from "@/hooks";

export const OrderBreadcrumb = (props: { orderId: string }) => {
  const { useGetOrder } = useOrders();
  const { data: order, isPending } = useGetOrder({
    orderId: props.orderId,
  });
  if (isPending) {
    return;
  }
  return <Link to={`/orders/${props.orderId}`}>{order?.data.name}</Link>;
};
